export default "__VITE_ASSET__a095ba96__"